<template>
    <DisclosurePanel
        v-if="product.addonProducts.length > 0"
        id="addons-details-content"
    >
        <div
            v-for="(addon, idx) in product.addonProducts"
            class="flex flex-col-reverse justify-between gap-4 rounded border border-gray-300 p-6 at480:flex-row at480:items-center at480:gap-6 at768:p-8"
            :data-testid="`addon-card-${idx}`"
        >
            <div class="flex flex-col gap-2">
                <div
                    class="flex flex-col gap-1 at600:flex-row at600:items-center at600:gap-2"
                >
                    <h5 class="text-[18px] font-semibold">
                        {{ addon.name }}
                    </h5>
                    <div class="flex items-center gap-1">
                        <span class="hidden text-gray-500 at600:inline"
                            >&plus;</span
                        >
                        <product-price
                            :price="addon.price"
                            show-shipping-if-not-free
                            class="text-sm font-normal text-gray-500 at600:text-base"
                        ></product-price>
                    </div>
                </div>
                <p class="text-xs at600:text-sm">
                    {{ addon.short_description }}
                </p>
                <a
                    @click.prevent="
                        selectedAddon = addon;
                        openAddonConfigModal();
                    "
                    href="#"
                    class="underline-offset-4"
                    :data-testid="`open-addon-config-modal-${idx}`"
                    >Add to booking</a
                >
            </div>
            <img
                :src="addon.thumbnail_url"
                class="w-32 rounded-sm object-cover"
            />
        </div>
    </DisclosurePanel>
</template>

<script setup>
import { DisclosurePanel } from '@headlessui/vue';
import AddonConfigModal from 'components/EventDetail/Details/Modals/AddonConfigModal.vue';
import ProductPrice from 'components/Global/ProductPrice';
import { inject, ref } from 'vue';
import { useModal } from 'vue-final-modal';
import VueScrollTo from 'vue-scrollto';

const product = inject('product');

const selectedAddon = ref(null);

const { open: openAddonConfigModal, close } = useModal({
    component: AddonConfigModal,
    attrs: {
        product: product,
        addon: selectedAddon,
        onAddonSelected: (addon) => {
            close();
            VueScrollTo.scrollTo('#checkout-form', {
                container: 'body',
                force: false,
                offset: -100,
            });
        },
    },
});
</script>
